import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  Renderer2,
  ViewChild,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'viewer-play-button',
  templateUrl: './viewer-play-button.component.html',
  styleUrl: './viewer-play-button.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ViewerPlayButtonComponent implements OnDestroy {
  @Input() playing: boolean = false;
  @Output() togglePlay: EventEmitter<void> = new EventEmitter<void>();

  private tooltipEl: HTMLDivElement | null = null;

  @ViewChild('playButton') playButton!: ElementRef<HTMLButtonElement>;

  constructor(private readonly renderer: Renderer2) {}

  public showTooltip(): void {
    const button: any = this.playButton?.nativeElement;
    if (!button) return;

    const tooltipText: string = this.playing ? 'Pause' : 'Play';

    if (!this.tooltipEl) {
      this.tooltipEl = this.renderer.createElement('div') as HTMLDivElement;
      this.tooltipEl.className = 'viewer-play-tooltip';
      this.tooltipEl.style.position = 'fixed';
      this.tooltipEl.style.pointerEvents = 'none';
      this.tooltipEl.style.zIndex = '20000';
      this.tooltipEl.style.visibility = 'hidden';

      this.renderer.appendChild(document.body, this.tooltipEl);
    }

    this.tooltipEl.textContent = tooltipText;
    this.tooltipEl.style.visibility = 'visible';
    // Measure after becoming visible so rect height is correct.
    this.positionTooltip();
  }

  public hideTooltip(): void {
    if (!this.tooltipEl) return;
    this.tooltipEl.style.visibility = 'hidden';
  }

  private positionTooltip(): void {
    if (!this.tooltipEl) return;
    const buttonRect: any = this.playButton.nativeElement.getBoundingClientRect();

    // Match old ::after positioning:
    // bottom: calc(100% + 8px) and transform translateX(-50% + 4px)
    this.tooltipEl.style.left = `${buttonRect.left + buttonRect.width / 2}px`;

    const tooltipHeight: number = this.tooltipEl.getBoundingClientRect().height || 24;
    this.tooltipEl.style.top = `${buttonRect.top - 10 - tooltipHeight}px`;

    this.tooltipEl.style.transform = 'translateX(calc(-50% + 4px))';
  }

  ngOnDestroy(): void {
    if (this.tooltipEl) {
      this.tooltipEl.remove();
      this.tooltipEl = null;
    }
  }
}
